import { teamsContextStore } from 'state/teamsContext';

import { lazyResetTeamsClientDataLayer } from './loadableResetTeamsClientDataLayer';
import { triggerCacheSync } from './serviceWorkerCacheSync';
import { unsubscribeTeamsFromPageLifecycleEvents } from './teamsPageLifecycleEvents';

type HandleBeforeUnloadApp = (readyToUnload: () => void) => boolean;

export const handleBeforeUnloadApp: HandleBeforeUnloadApp = (readyToUnload) => {
  lazyResetTeamsClientDataLayer();
  unsubscribeTeamsFromPageLifecycleEvents();

  triggerCacheSync();

  readyToUnload();

  teamsContextStore.getState().setIsCached(true);

  return true;
};
